<template>
  <div class="medical-decision-summary">


    <div v-b-tooltip.hover class="decision-option" :title="$translate('num_frozen')">
      <img :src="buildSvgPath('FROZEN')" alt=""/>
      <span>{{ amount.frozen }}</span>
    </div>


    <div v-b-tooltip.hover class="decision-option" :title="$translate('num_transferred')">
      <img :src="buildSvgPath('TRANSFERRED')" alt=""/>
      <span>{{ amount.transferred }}</span>
    </div>

    <div v-b-tooltip.hover class="decision-option" :title="$translate('num_discarded')">
      <img :src="buildSvgPath('DISCARDED')" alt=""/>
      <span>{{ amount.discarded }}</span>
    </div>
  </div>
</template>

<script>
import {WELL_STATUS} from '../../../business/factory/DataModel'
import {WELL_STATUS_ICONS_PATH} from '../../../business/const'

export default {
  name: 'MedicalDecisionSummary',
  props: {
    wells: {
      type: Array,
      required: true
    }
  },
  computed: {
    activeWells() {
      return this.wells.filter(well => !!well)
    },
    amount() {
      const {DISCARDED, FROZEN, TRANSFERRED, PENDING, THAWED} = WELL_STATUS

      return {
        pending: this.activeWells.filter(well => well.status === PENDING).length,
        discarded: this.activeWells.filter(well => well.status === DISCARDED).length,
        frozen: this.activeWells.filter(well => well.status === FROZEN).length,
        transferred: this.activeWells.filter(well => well.status === TRANSFERRED).length,
        thawed: this.activeWells.filter(well => well.status === THAWED).length
      }
    }
  },
  methods: {
    buildSvgPath(fate) {
      return `${WELL_STATUS_ICONS_PATH}/${fate}.svg`
    }
  }
}
</script>

<style lang="scss" scoped>
.medical-decision-summary {
  display: flex;
  align-items: center;
  justify-content: stretch;
  color: $light-3;
  font-size: 10pt;
  white-space: nowrap;

  .decision-option {
    line-height: 100%;
    display: flex;
    align-items: center;
    justify-content: stretch;
    margin: 0 0.2rem;

    img {
      height: 0.8rem;
      margin-right: 0.1rem;
    }

    &:nth-child(2) {
      margin: 0 0.25rem;
    }
  }
}
</style>
